import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-47f6c8de"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"position":"relative","height":"calc(100vh)","background-color":"rgb(10, 29, 52)","overflow-y":"auto"} }
const _hoisted_2 = { class: "navigator" }
const _hoisted_3 = { class: "navigator-head" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"justify-content":"flex-start","color":"#dcfafa"} }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"justify-content":"center","font-size":"1rem","font-weight":"600","font-style":"italic"} }, "KRI DIGITALIZE", -1))
const _hoisted_6 = { style: {"justify-content":"flex-end"} }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("跳转大区")
const _hoisted_8 = { style: {"color":"#4d9fff","display":"flex","justify-content":"center","align-items":"center","font-size":"0.7rem","height":"1.6rem"} }
const _hoisted_9 = {
  class: "report-body",
  style: {"padding-top":"2rem"}
}
const _hoisted_10 = { class: "panel-title" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "risk-grade-head" }, [
  /*#__PURE__*/_createElementVNode("div")
], -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "panel-title" }, "风险模块定级", -1))
const _hoisted_13 = { class: "risk-grade-body" }
const _hoisted_14 = { class: "risk-card-item" }
const _hoisted_15 = ["src"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "panel-title" }, "风险雷达", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "risk-grade-head" }, [
  /*#__PURE__*/_createElementVNode("div")
], -1))
const _hoisted_18 = { class: "report-body" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "panel-title" }, "高风险指标汇总", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "risk-grade-head" }, [
  /*#__PURE__*/_createElementVNode("div")
], -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "panel-title" }, "逆向事件汇总", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "risk-grade-head" }, [
  /*#__PURE__*/_createElementVNode("div")
], -1))
const _hoisted_23 = { class: "report-body" }
const _hoisted_24 = { class: "panel-title" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "risk-grade-head" }, [
  /*#__PURE__*/_createElementVNode("div")
], -1))
const _hoisted_26 = { style: {"display":"flex"} }
const _hoisted_27 = { style: {"width":"calc(55% - 60px)"} }
const _hoisted_28 = { style: {"width":"calc(45% + 50px)"} }

import { computed, reactive, ref } from 'vue';
import stubs from '@/init';
import { useRoute } from 'vue-router';

// component
import Panel from './views/Panel.vue';
import SubsidiaryRiskLevelPanel from './views/SubsidiaryRiskLevelPanel.vue';
import RadarOrBarChart from './views/RadarOrBarChart.vue';
import ReportTable from './views/ReportTable.vue';
import ReverseEventPanel from './views/ReverseEventPanel.vue';
import KriMetricsList from './views/KriMetricsList.vue';

// controller
import CockpitController from './controller/Cockpit.Controller';
import CockpitSubsidiaryController from './controller/CockpitSubsidiary.Controller';

// vo
import { SimpleItem } from '@velites/common/src';
import { CockpitYearVO, RiskModuleKriVO, SubsidiaryVO } from './vo';

import { params } from './common';

// utils
import { gradeToDescription } from '@/utils/utilsHandle';
// 初始化 ECharts 实例

export default /*#__PURE__*/_defineComponent({
  setup(__props, { expose }) {

const cockpitController: CockpitController =
  stubs.injector.get(CockpitController);
const cockpitSubsidiaryController: CockpitSubsidiaryController =
  stubs.injector.get(CockpitSubsidiaryController);

const state = reactive({
  options: [] as SimpleItem[],
  years: [] as CockpitYearVO[],
  subsidiary: {} as SubsidiaryVO,
  detailPanelPosition: {
    top: '0px',
    left: '0px',
  },
});
const updateKey = ref(Math.random())
const regions = computed(() => {
  return (state.years.find((it) => it.year === params.year)?.region || []).map(
    (it) => ({ label: it.name, value: it.id })
  );
});
const subsidiary = computed(() => {
  return (state.years.find((it) => it.year === params.year)?.subsidiary || [])
    .filter((it) => !params.regionId || params.regionId === it.regionId)
    .map((it) => ({ label: it.name, value: it.id }));
});

// methods
const selectYear = async (year: string) => {
  params.year = year;
  state.subsidiary = await cockpitSubsidiaryController.region(
    params.subsidiaryId,
    year
  );
  params.subsidiaryId = state.subsidiary.id;
  params.regionId = state.subsidiary.regionId;
  updateKey.value = Math.random();
};

const selectRegion = async () => {
  setTimeout(() => {
    if (subsidiary.value?.length) {
      selectSubsidiary(subsidiary.value[0].value);
    }
  });
  updateKey.value = Math.random();
};

const selectSubsidiary = async (subsidiary: string) => {
  params.subsidiaryId = subsidiary;
  state.subsidiary = await cockpitSubsidiaryController.region(
    params.subsidiaryId,
    params.year
  );
  updateKey.value = Math.random();
};

const init = async () => {
  const years = await cockpitController.year();
  state.years = years;
  state.options = years.map((it) => ({
    label: it.year + '',
    value: it.year + '',
  }));
  if (params.year) {
    selectYear(params.year);
  } else if (state.options.length) {
    selectYear(state.options[0].value as string);
  }
};

const pat = (arr: RiskModuleKriVO[], key = 'name') => {
  return (arr || []).reduce(
    (prev, cur) => prev.concat(cur.kriMetricsList),
    [] as any[]
  ).filter((it) => it.kriLevel && it.type === 'NORMAL').map((it: any) => it[key]);
};

const getModuleList = (key = 'name') => (state.subsidiary?.moduleList || []).filter((module) => module.level).map((it: any) => it[key])

init();

expose({
  init,
});

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_simple_select = _resolveComponent("simple-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_el_button, {
            style: {"margin-right":"0.2rem"},
            class: "bottom-button",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/region')))
          }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          }),
          _createVNode(_component_simple_select, {
            style: {"margin-right":"0.2rem","width":"5rem"},
            options: _unref(state).options,
            modelValue: _unref(params).year,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(params).year) = $event)),
            onChange: selectYear
          }, null, 8, ["options", "modelValue"]),
          _createVNode(_component_simple_select, {
            style: {"margin-right":"0.2rem","width":"5rem"},
            options: _unref(regions),
            filterable: "",
            clearable: "",
            placeholder: "选择大区以限制城市范围",
            onChange: selectRegion,
            modelValue: _unref(params).regionId,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(params).regionId) = $event))
          }, null, 8, ["options", "modelValue"]),
          _createVNode(_component_simple_select, {
            style: {"width":"5rem"},
            options: _unref(subsidiary),
            modelValue: _unref(params).subsidiaryId,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(params).subsidiaryId) = $event)),
            filterable: "",
            onChange: selectSubsidiary
          }, null, 8, ["options", "modelValue"])
        ])
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(state).subsidiary?.name), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createVNode(Panel, {
        class: "first-row",
        style: {"padding":"25px","margin-bottom":"10px","width":"calc(22% - 6px)","margin-right":"10px"}
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(state).subsidiary.name) + "风险定级", 1),
          _hoisted_11,
          _createElementVNode("div", null, [
            _createVNode(SubsidiaryRiskLevelPanel, {
              style: {"width":"100%"},
              level: _unref(state).subsidiary?.level,
              "trend-level": _unref(state).subsidiary?.trendLevel,
              "high-risk-module-count": _unref(state).subsidiary?.highRiskModuleCount,
              "high-risk-kri-metrics-count": 
              _unref(state).subsidiary?.highRiskKriMetricsCount
            
            }, null, 8, ["level", "trend-level", "high-risk-module-count", "high-risk-kri-metrics-count"])
          ])
        ]),
        _: 1
      }),
      _createVNode(Panel, {
        class: "first-row",
        style: {"padding":"25px","margin-bottom":"10px","width":"calc(56% - 10px)","margin-right":"10px"}
      }, {
        default: _withCtx(() => [
          _hoisted_12,
          _createElementVNode("div", _hoisted_13, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).subsidiary.moduleList, (item) => {
              return (_openBlock(), _createElementBlock("div", null, [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", null, [
                    _createElementVNode("img", {
                      src: 
                    require(`@/assets/images/home/grade-${item.level || 1}.png`)
                  
                    }, null, 8, _hoisted_15),
                    _createElementVNode("span", null, _toDisplayString(item.level), 1)
                  ]),
                  _createElementVNode("div", {
                    class: _normalizeClass(["year-on-year", { red: item.trendLevel < 0 }])
                  }, _toDisplayString(_unref(gradeToDescription)(item.trendLevel || 0)), 3)
                ]),
                _createElementVNode("div", {
                  class: _normalizeClass(["module-name", `level-${item.level || 1}`])
                }, _toDisplayString(item.name), 3)
              ]))
            }), 256))
          ])
        ]),
        _: 1
      }),
      _createVNode(Panel, {
        class: "first-row",
        style: {"padding":"25px","margin-bottom":"10px","width":"calc(22% - 6px)"}
      }, {
        default: _withCtx(() => [
          _hoisted_16,
          _hoisted_17,
          _createElementVNode("div", null, [
            (_openBlock(), _createBlock(RadarOrBarChart, {
              style: {"width":"100%"},
              key: updateKey.value,
              categories: 
              getModuleList('name')
            ,
              values: [
              getModuleList('level'),
            ]
            }, null, 8, ["categories", "values"]))
          ])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_18, [
      _createVNode(Panel, {
        class: "first-row",
        style: {"padding":"25px","margin-bottom":"10px","width":"calc(50% - 10px)","margin-right":"10px"}
      }, {
        default: _withCtx(() => [
          _hoisted_19,
          _hoisted_20,
          _createElementVNode("div", null, [
            _createVNode(ReportTable, {
              data: _unref(state).subsidiary.highRiskKriMetricsModuleList
            }, null, 8, ["data"])
          ])
        ]),
        _: 1
      }),
      _createVNode(Panel, {
        class: "first-row",
        style: {"padding":"25px","margin-bottom":"15px","width":"calc(50% - 10px)"}
      }, {
        default: _withCtx(() => [
          _hoisted_21,
          _hoisted_22,
          _createElementVNode("div", null, [
            _createVNode(ReverseEventPanel, {
              data: _unref(state).subsidiary.reverseEventModuleList
            }, null, 8, ["data"])
          ])
        ]),
        _: 1
      })
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).subsidiary.moduleList, (item) => {
      return (_openBlock(), _createElementBlock("div", _hoisted_23, [
        _createVNode(Panel, {
          class: "first-row",
          style: {"padding":"25px","margin-bottom":"10px","width":"calc(100% - 10px)","margin-right":"10px","height":"16rem"}
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_24, _toDisplayString(item.name), 1),
            _hoisted_25,
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                _createVNode(KriMetricsList, {
                  data: item.riskModuleKriList
                }, null, 8, ["data"])
              ]),
              _createElementVNode("div", _hoisted_28, [
                _createVNode(RadarOrBarChart, {
                  style: {"width":"100%","height":"12rem"},
                  categories: pat(item.riskModuleKriList, 'name'),
                  values: [pat(item.riskModuleKriList, 'kriLevel')]
                }, null, 8, ["categories", "values"])
              ])
            ])
          ]),
          _: 2
        }, 1024)
      ]))
    }), 256))
  ]))
}
}

})